export class PathUtils {
	/* L18n, redirect hook */
	public static removeSurroundingSlashes(path: string) {
		if (path.charAt(0) === '/') path = path.slice(1);
		if (path.charAt(path.length - 1) === '/') path = path.slice(0, -1);
		return path;
	}

	/* this.getModelPath */
	public static join(...parts: string[]) {
		for (let i = 0; i < parts.length; i++) {
			parts[i] = parts[i].replace(/\/$/, '');
		}
		return parts.join('/');
	}

	/* L18n */
	public static getSlugAtIndex(url: string, index: number) {
		url = PathUtils.removeSurroundingSlashes(url);
		if (url.startsWith('http')) {
			const urlObj = new URL(url);
			url = urlObj.pathname;
			index++;
		}
		if (url.startsWith('www.')) {
			index++;
		}
		if (url.split('/')[0].includes(':')) {
			index++;
		}

		const parts = url.split('/');
		return parts[index];
	}

	/* L18n */
	public static removeSlug(url: string, index: number) {
		const hasLeadingSlash = url.startsWith('/');
		url = PathUtils.removeSurroundingSlashes(url);

		let origin = hasLeadingSlash ? '/' : '';
		if (url.startsWith('http')) {
			const urlObj = new URL(url);
			origin = urlObj.origin;
			url = urlObj.pathname;
			index++;
		}
		if (url.startsWith('www.')) {
			index++;
		}
		if (url.split('/')[0].includes(':')) {
			index++;
		}

		const parts = url.split('/');
		parts.splice(index, 1);
		url = parts.join('/');

		return origin + url;
	}

	/* L18n */
	public static addSlug(url: string, slug: string, index: number) {
		const hasLeadingSlash = url.startsWith('/');
		url = PathUtils.removeSurroundingSlashes(url);

		let origin = hasLeadingSlash ? '/' : '';
		if (url.startsWith('http')) {
			const urlObj = new URL(url);
			origin = urlObj.origin;
			url = urlObj.pathname;
			index++;
		}
		if (url.startsWith('www.')) {
			index++;
		}
		if (url.split('/')[0].includes(':')) {
			index++;
		}

		const parts = url.split('/');
		parts.splice(index, 0, slug);
		url = parts.join('/');

		return origin + url;
	}

	private static oeRegex = /ø/g;
	private static aeRegex = /æ/g;
	private static normRegex = /[\u0300-\u036f]/g;
	private static whitespaceRegex = /\s+/g;
	private static nontextRegex = /[^a-z0-9]+/g;

	public static slugify(name: string) {
		if (!name) return '';
		name = name.toLowerCase();
		name = name.replace(PathUtils.oeRegex, 'o');
		name = name.replace(PathUtils.aeRegex, 'ae');
		name = name.normalize('NFD').replace(PathUtils.normRegex, '');
		name = name.replace(PathUtils.whitespaceRegex, '-');
		name = name.replace(PathUtils.nontextRegex, '-');
		name = name.split('-').filter(Boolean).join('-');
		return name;
	}

	public static clean(path: string) {
		const parts = path.split('/').filter((p) => p.length > 0);
		const pathname = '/' + parts.join('/');
		return pathname;
	}
}
